// function createMarquee(selector, speed) {
//   const parentSelector = document.querySelector(selector);
//   const clone = parentSelector.innerHTML;
//   const firstElement = parentSelector.children[0];
//   let i = 0;

//   parentSelector.insertAdjacentHTML("beforeend", clone);
//   parentSelector.insertAdjacentHTML("beforeend", clone);

//   setInterval(function () {
//     firstElement.style.marginLeft = `-${i}px`;
//     if (i > firstElement.clientWidth) {
//       i = 0;
//     }
//     i = i + speed;
//   }, 0);
// }

//after window is completed load
//1 class selector for marquee
//2 marquee speed 0.2

// window.addEventListener("load", event => {
//   createMarquee(".marquee", 0.2)
// });

if (customElements.get('natalies-marquee') === undefined) {
  class NataliesMarquee extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.parentSelector = this.querySelector('.marquee__gutter');
      const clone = this.parentSelector.innerHTML;
      this.i = 0;

      this.parentSelector.insertAdjacentHTML("beforeend", clone);
      this.parentSelector.insertAdjacentHTML("beforeend", clone);

      this.animate();
    }

    animate() {
      this.parentSelector.style.transform = `translate3d(${-this.i}px, 0, 0)`;

      const width = this.firstElement.clientWidth;
      if (this.i > width) {
        this.i = 0;
      } else {
        this.i += this.speed; // now numeric
      }

      requestAnimationFrame(() => {

        this.animate();
      });
    }

    get speed() {
      return this.dataset.speed*1 || 0.2;
    }

    get firstElement() {
      return this.querySelector('.marquee__gutter').children[0];
    }

  }

  customElements.define('natalies-marquee', NataliesMarquee);
}
